<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="grid-col grid-col--soft grid-xsmall-12 grid-large-9 push__top push__bottom">
        <div class="push__bottom">
            <BackLink/>
        </div>
        <div class="wysiwyg">
            <h1 v-html="title">Title</h1>
            <div class="alert">
                <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>
                <p>{{ warningText }}</p>
            </div>
            <div v-html="content"></div>
            <p>
                <button class="btn btn--primary" @click="startQuestionnaire">{{buttonText}}</button>
            </p>
        </div>                
      </article>
    </div>
  </div>
</template>

<script>
import { dataService } from "../shared";

export default {
  name: "EpilepsyQuestionaire",
  created() {
    this.loadQuestion();
  },
  data() {
    return {
      id : "",
      title: "",
      content: "",
      destination: "",
      warningText: ""
    };
  },
  methods: {
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      console.log(currentQuestion);
      this.id = currentQuestion.id;
      this.title = currentQuestion.title;
      this.content = currentQuestion.content;
      this.buttonText = currentQuestion.buttonText;
      this.warningText = currentQuestion.warningText;
      this.destination = currentQuestion.destination;
    },
    startQuestionnaire() {        
      this.$router.push({ name: this.destination.toLowerCase() });
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>